import { render, staticRenderFns } from "./OnlineService.vue?vue&type=template&id=3533db78&scoped=true&"
import script from "./OnlineService.vue?vue&type=script&lang=js&"
export * from "./OnlineService.vue?vue&type=script&lang=js&"
import style0 from "./OnlineService.vue?vue&type=style&index=0&id=3533db78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3533db78",
  null
  
)

component.options.__file = "OnlineService.vue"
export default component.exports